/**
 * @license
 * Copyright UX Stack. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at LICENSE.md
 */

import { Logger, LoggerLevel } from './logger';
import './polyfill';
import { UXStack } from './uxstack';

if (process.env.NODE_ENV === 'development') {
  Logger.level = LoggerLevel.DEBUG;
}

class CallExpr {
  public static parse(args: any[]): CallExpr {
    const fn = args.shift();

    const call = new CallExpr();

    const pos = fn.indexOf('.');

    if (pos >= 0) {
      call.module = fn.substr(0, pos);
      call.func = fn.substr(pos + 1);
    } else {
      call.func = fn;
    }

    call.args = args;

    return call;
  }

  public module?: string;
  public func: string;
  public args: any[];

  public isModule(): boolean {
    return this.module !== undefined;
  }
}

// tslint:disable-next-line:only-arrow-functions no-empty
window.uxstack =
  window.uxstack ||
  function (): void {
    Logger.debug('init stub uxstack');
  };

window.uxstack.calls = window.uxstack.calls || [];

const calls = window.uxstack.calls;
Logger.debug('backup calls', calls);

const sdk = new UXStack();

Logger.debug('swap uxstack func');
// tslint:disable-next-line:only-arrow-functions
window.uxstack = function (): void {
  const args: string[] = Array.from(arguments);

  const call = CallExpr.parse(args);

  if (call.isModule()) {
    Logger.debug('call %s.%s(%s)', call.module, call.func, call.args.join(', '));

    const module = sdk.getModule(call.module);

    (module as any)[call.func].apply(module, args);
  } else {
    Logger.debug('call %s(%s)', call.func, call.args.join(', '));

    (sdk as any)[call.func].apply(sdk, args);
  }
};

function init(isAdBlock: boolean): void {
  calls.forEach((args: any[]) => {
    if (args[0] === 'create' && args[2] != undefined) {
      args[2].modules.track.adblock = isAdBlock;
    }

    window.uxstack.apply(null, args);
  });
}

let isAdBlock = false;

const adScript = document.createElement('script');
adScript.src = document.currentScript.getAttribute('src').replace('/uxstack.js', '') + '/content-ads.js';
adScript.async = true;
adScript.onload = (): void => {
  Logger.info('No AdBlock detected');

  isAdBlock = false;

  init(isAdBlock);
};
adScript.onerror = (): void => {
  Logger.info('AdBlock detected');

  isAdBlock = true;

  init(isAdBlock);
};

document.head.appendChild(adScript);
